module.exports = __webpack_public_path__ + "images/editDarkBg.ee74adde.svg";